/* global G */
import { modelComposition } from 'trait/composition'
import { pipe } from 'lib/util'
import { usesGetterSetter } from 'trait/uses'
import toRef from 'model/_shared/transformer/toRef'

const descriptor = 'model::adminNotice'

export default pipe(
  modelComposition(descriptor),
  usesGetterSetter(G.TRANSFORMER, {
    submitter: toRef('submitter'),
  }),
)
